import React from 'react';
import { Input } from '../Input';

interface NumberInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  controlClassName?: string;
  icon?: React.ReactNode;
  iconClassName?: string;
}

const NumberInput = React.forwardRef<HTMLInputElement, NumberInputProps>((props, ref) => (
  <Input
    ref={ref}
    type="number"
    {...props}
  />
));

NumberInput.displayName = 'NumberInput';

export { NumberInput };
